import { BaseButton } from "@/components/ui-kit/Buttons/BaseButton";
import { ButtonType } from "@/types/ui-kit/buttons";
import Link from "next/link";
import React from "react";
import { BaseDialogModalWindow } from "@/components/modules/Post/BaseDialogModalWindow";
import { useAuthUrls } from "@/hooks/useAuthUrls";

export const SuccessDialogModalWindow: React.FC<{ isOpen: boolean; onClose: () => void }> = ({ isOpen, onClose }) => {
  const { getLoginUrl, getRegisterUrl } = useAuthUrls();

  return (
    <BaseDialogModalWindow isOpen={isOpen} onClose={onClose}>
      <h3 className="mb-[8px] font-mercury text-xl font-semibold text-dark">Blahopřejeme, máte dobré přátele!</h3>
      <div className="mb-[24px]">
        <p className="font-body font-light text-dark-70">
          Tento článek je normálně zamčený, ale vy si jej můžete přečíst zdarma. Text se vám odemkne po registraci ,
          nebo přihlášení k vašem uživatelskému účtu.
        </p>
      </div>
      <div className="flex w-full flex-col gap-[16px]">
        <div className="w-full overflow-hidden rounded-full">
          <BaseButton href={getRegisterUrl()} title="Registrovat" type={ButtonType.Primary} />
        </div>
        {/* TODO: change for transparent button when it's merged from other PR */}
        <Link href={getLoginUrl()}>
          <button
            type="button"
            className="block w-full cursor-pointer rounded-full border border-gray-300 p-3 text-center font-sans text-sm transition-colors ease-in-out hover:bg-dark/5 active:bg-dark/10"
          >
            Pokud už účet máte, přihlaste se
          </button>
        </Link>
      </div>
    </BaseDialogModalWindow>
  );
};
